export const KLARNA_MIN_SPEND = 30;
export const KLARNA_MAX_SPEND = 2000;
export const KLARNA_PAY_IN_30_MIN_SPEND = 30;
export const KLARNA_PAY_IN_30_MAX_SPEND = 600;
export const PAYPAL_PAY_LATER_MIN_SPEND = 30;
export const PAYPAL_PAY_LATER_MAX_SPEND = 2000;
